
export interface GlobalCacheItem {
  id: string;
  type: string;
  difficulty: string;
  content: any;
  created_at?: string;
}

export const globalCache = {
  /**
   * Fetch a random item from the global pool matching the criteria.
   * Returns null if API is down or no item is found.
   */
  async fetchCachedItem(type: string, difficulty: string): Promise<GlobalCacheItem | null> {
    try {
      const url = new URL('/api/activities', window.location.origin);
      url.searchParams.append('type', type);
      url.searchParams.append('difficulty', difficulty);

      const response = await fetch(url.toString());

      if (!response.ok) {
        console.warn('Global Cache Read Error:', response.statusText);
        return null;
      }

      const data = await response.json();

      if (data) {
        return data as GlobalCacheItem;
      }

      return null;
    } catch (e) {
      console.warn('Global Cache Network Error:', e);
      return null;
    }
  },

  /**
   * Push a newly generated item to the global pool.
   * Fire-and-forget; we don't block the UI if this fails.
   */
  async cacheItem(item: GlobalCacheItem): Promise<boolean> {
    try {
      const response = await fetch('/api/activities', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(item)
      });

      if (!response.ok) {
        console.warn('Global Cache Write Error:', response.statusText);
        return false;
      }

      const result = await response.json();
      return result.success || false;
    } catch (e) {
      console.warn('Global Cache Network Error:', e);
      return false;
    }
  }
};
